/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDisc = createReactComponent("disc", "IconDisc", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-1" }],
  ["path", { d: "M7 12a5 5 0 0 1 5 -5", key: "svg-2" }],
  ["path", { d: "M12 17a5 5 0 0 0 5 -5", key: "svg-3" }]
]);

export { IconDisc as default };
//# sourceMappingURL=IconDisc.js.map
